import { createFileRoute } from '@tanstack/react-router';
import { groupsQueryOptions } from '@entities/group';
import { DashboardPage } from '@pages/dashboard';

export const Route = createFileRoute('/_authenticated/')({
  staticData: { railRight: true },
  loader: ({ context }) => {
    // Warm the cache so the dashboard paints instantly; the hook dedupes.
    void context.queryClient.ensureQueryData(groupsQueryOptions);
  },
  component: DashboardPage,
});
